module.exports = __webpack_public_path__ + "static/media/facebook.a8249830.svg";